// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SOPListing from './SOPListing';
import SOPDetail from './SOPDetail';
import SOPEditor from './SOPEditor';
import SOPVersionHistory from './SOPVersionHistory';
import SOPVersionDetail from './SOPVersionDetail';

function SOPLayout() {
  return (
    <Routes>
      <Route path="/" element={<SOPListing />} />
      <Route path="new" element={<SOPEditor />} />
      <Route path=":sopId" element={<SOPDetail />} />
      <Route path=":sopId/edit" element={<SOPEditor />} />
      <Route path=":sopId/versions" element={<SOPVersionHistory />} />
      <Route path=":sopId/versions/:versionId" element={<SOPVersionDetail />} />
    </Routes>
  );
}

export default SOPLayout;
